import { WebsiteBuildersComponent } from './features/websites/website-builders.component';
import { StaffCanDirective } from './shared/staff-can.directive';
import { NgModule, provideBrowserGlobalErrorListeners, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { RoleDetailComponent } from './features/roles-permissions/role-detail/role-detail.component';
import { Sidebar } from './shared/components/sidebar/sidebar';
import { Header } from './shared/components/header/header';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { RolesPageComponent } from './features/roles-permissions/roles-page/roles-page.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomePageComponent } from './features/home/home-page/home-page.component';
import { PermissionsPageComponent } from './features/roles-permissions/permissions-page/permissions-page.component';
import { UserRolesPageComponent } from './features/roles-permissions/user-roles-page/user-roles-page.component';
import { UserBusinessesComponent } from './features/roles-permissions/user-businesses/user-businesses.component';
import { BusinessPermissionsComponent } from './features/roles-permissions/business-permissions/business-permissions.component';
import { BusinessesPageComponent } from './features/businesses/businesses-page/businesses-page.component';
import { BusinessProfileComponent } from './features/businesses/business-profile/business-profile.component';
import { BusinessIntelligencePanelComponent } from './features/businesses/intelligence-panel/intelligence-panel.component';
import { BusinessWebsitesPanelComponent } from './features/businesses/websites-panel/websites-panel.component';
import { BusinessAiImagesPanelComponent } from './features/businesses/ai-images-panel/ai-images-panel.component';
import { BusinessFeaturesPanelComponent } from './features/businesses/features-panel/features-panel.component';
import { UnauthorizedPageComponent } from './features/home/unauthorized-page/unauthorized-page.component';
import { SplashPageComponent } from './features/home/splash-page/splash-page.component';
import { LogoutCallbackComponent } from './features/home/logout-callback/logout-callback.component';
import { ProductsPageComponent } from './features/products/products-page.component';
import { PendingProductChangesComponent } from './features/products/pending-product-changes.component';
import { MarketplaceCatalogComponent } from './features/products/marketplace-catalog.component';
import { UserProfileComponent } from './features/users/user-profile/user-profile.component';
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from './services/auth/auth.service';
import { timezoneInterceptor } from './interceptor/timezone-interceptor.interceptor';
import { GlobalErrorHandler } from './services/global-error-handler.service';
import { LoadingInterceptor } from './interceptor/loading.interceptor';
import { AuthInterceptor } from './interceptor/authInterceptor';
import { PendingSellerChangesComponent } from './features/marketplace/pending-seller-changes.component';
import { CachePageComponent } from './features/system/cache-page/cache-page.component';
import { ImageDerivativesPageComponent } from './features/system/image-derivatives-page/image-derivatives-page.component';
import { ConfigCheckPageComponent } from './features/system/config-check-page/config-check-page.component';
import { MaintenancePageComponent } from './features/system/maintenance-page/maintenance-page.component';
import { BusinessMaintenancePanelComponent } from './features/businesses/maintenance-panel/business-maintenance-panel.component';
import { TerminalsPageComponent } from './features/terminals/terminals-page/terminals-page.component';
import { EditLockBarComponent } from './shared/components/edit-lock-bar/edit-lock-bar.component';
import { BusinessFamilyPanelComponent } from './features/businesses/business-family/business-family-panel.component';
import { CustomerDisplayPanelComponent } from './features/businesses/customer-display/customer-display-panel.component';



@NgModule({
  declarations: [
    App,
    RolesPageComponent,
    RoleDetailComponent,
    Sidebar,
    Header,
    HomePageComponent,
    SplashPageComponent,
    PermissionsPageComponent,
    UserRolesPageComponent
    ,UserBusinessesComponent
    ,BusinessPermissionsComponent
    ,BusinessesPageComponent
    ,BusinessProfileComponent
    ,BusinessIntelligencePanelComponent
    ,BusinessWebsitesPanelComponent
    ,BusinessAiImagesPanelComponent
    ,BusinessFeaturesPanelComponent
    ,UnauthorizedPageComponent
    ,LogoutCallbackComponent
    ,ProductsPageComponent
    ,PendingProductChangesComponent
    ,MarketplaceCatalogComponent
    ,PendingSellerChangesComponent
    ,UserProfileComponent
    ,CachePageComponent
    ,ImageDerivativesPageComponent
    ,ConfigCheckPageComponent
    ,MaintenancePageComponent
    ,TerminalsPageComponent
    ,EditLockBarComponent
  ],
  imports: [
    WebsiteBuildersComponent,
    StaffCanDirective,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    AppRoutingModule,
    BusinessFamilyPanelComponent,
    CustomerDisplayPanelComponent,
    BusinessMaintenancePanelComponent,
    OAuthModule.forRoot()
  ],
  providers: [
    OAuthService,
    // Hints and errors sit in the layout flow and grow with their text. The default ('fixed')
    // absolutely positions them with one reserved line, so multi-line hints paint over the
    // control below - most visibly in the seller application dialogs.
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: 'dynamic' }
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([timezoneInterceptor])),
     {
       provide: ErrorHandler,
       useClass: GlobalErrorHandler
     },
    provideBrowserGlobalErrorListeners(),
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => () => authService.initAuth(),
      deps: [AuthService],
      multi: true
    }
  ],
  bootstrap: [App]
})
export class AppModule {}
